export default __webpack_public_path__ + "static/Euro-50532607a5bb9ffc9331477de5a5c742.png";